import { Drawer, Descriptions, Divider } from 'antd';
import dayjs from 'dayjs';

function ViewCustomerType({ open, onClose, customerType }) {
  if (!customerType) {
    return null;
  }

  return (
    <Drawer
      title="Customer Type Details"
      width={700}
      onClose={onClose}
      open={open}
      footer={null}
    >
      <Descriptions column={1} bordered>
        <Descriptions.Item label="Customer Type">
          {customerType.name || 'N/A'}
        </Descriptions.Item>
      </Descriptions>

      <Divider orientation="left">Audit Information</Divider>

      <Descriptions column={1} bordered>
        <Descriptions.Item label="Created At">
          {customerType.created_at
            ? dayjs(customerType.created_at).format('DD-MM-YYYY HH:mm:ss')
            : 'N/A'}
        </Descriptions.Item>
        <Descriptions.Item label="Created By">
          {customerType.created_by && typeof customerType.created_by === 'object'
            ? `${customerType.created_by.first_name || ''} ${
                customerType.created_by.last_name || ''
              }`.trim() || 'N/A'
            : 'N/A'}
        </Descriptions.Item>
        <Descriptions.Item label="Updated At">
          {customerType.updated_at
            ? dayjs(customerType.updated_at).format('DD-MM-YYYY HH:mm:ss')
            : 'N/A'}
        </Descriptions.Item>
        <Descriptions.Item label="Updated By">
          {customerType.updated_by && typeof customerType.updated_by === 'object'
            ? `${customerType.updated_by.first_name || ''} ${
                customerType.updated_by.last_name || ''
              }`.trim() || 'N/A'
            : 'N/A'}
        </Descriptions.Item>
      </Descriptions>
    </Drawer>
  );
}

export default ViewCustomerType;
